module.exports = __webpack_public_path__ + "img/menu.svg";